interface GridHiddenTimesNoticeProps {
  /** Rows taken out of the view, sorted. */
  times: string[];
  onShow: () => void;
}

/** The way back for rows taken out of a grid with their X. Renders nothing while none is out. */
export function GridHiddenTimesNotice({ times, onShow }: GridHiddenTimesNoticeProps) {
  if (times.length === 0) return null;
  return (
    <p className="text-xs text-gray-500">
      {times.length === 1 ? 'Horario oculto: ' : 'Horarios ocultos: '}
      {times.join(', ')}.{' '}
      <button
        type="button"
        className="font-medium text-gray-700 underline hover:text-gray-900"
        onClick={onShow}
      >
        Mostrar
      </button>
    </p>
  );
}
